<template>
  <div class="last-functional-wrapper" ref="wrapperRef">
    <div class="last-func-wraoper">
      <img
        v-if="isMobile && userStore.userDetail.user_id"
        :src="headshotImg"
        class="user-headshot"
        @click="handleMyPage"
      />

      <template v-if="userStore.userDetail.user_id">
        <button v-if="!isMobile" class="user-btn pc" @click="toggleDropdown">
          <span>{{ $t('common.hi') }} {{ userStore.userDetail.username }}</span>
        </button>

        <button v-if="isMobile" class="logout-btn" @click="handleLogout">
          <i-local-logout class="logout-icon" />
        </button>

        <transition v-if="!isMobile" name="dropdown-pc">
          <div v-if="showDropdown" class="user-dropdown pc">
            <div class="logout-option pc" @click="handleLogout">
              {{ $t('user.logout') }}
            </div>
          </div>
        </transition>
      </template>

      <button
        v-if="!userStore.userDetail.user_id"
        class="login-btn"
        @click="handleLogin"
      >
        {{ $t('login.login') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { logoutUser } from '@/api'

const router = useRouter()
const userStore = useUserStore()
const appStore = useAppStore()
const { t } = useI18n()

const props = defineProps({
  isMobile: { type: Boolean, default: false },
  show: { type: Boolean, default: false }
})

const emit = defineEmits(['toggle', 'logout', 'login', 'my-page'])

const wrapperRef = ref(null)
const showDropdown = ref(props.show)

const headshotImg = computed(() => {
  const img = userStore.userDetail.headshot

  return img
    ? img
    : new URL('@/assets/images/default-profile-picture.png', import.meta.url)
        .href
})

const toggleDropdown = () => {
  emit('toggle')
}

const handleLogout = async () => {
  emit('logout')
}

const handleLogin = () => {
  emit('login')
}

const handleMyPage = () => {
  emit('my-page')
}

watch(
  () => props.show,
  (val) => {
    showDropdown.value = val
  }
)

defineExpose({
  wrapperRef
})
</script>

<style lang="scss" scoped>
.last-functional-wrapper {
  @include respond-down('md') {
    flex: 1;
    display: flex;
    align-items: flex-end;
  }

  .last-func-wraoper {
    position: relative;
    @include respond-down('md') {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .user-headshot {
      @include adapt($prop: width, $h5: 80);
      @include adapt($prop: height, $h5: 80);
      border-radius: 50%;
      cursor: pointer;
    }

    .user-btn {
      &.pc {
        @include flex-center;
        min-width: pc(216);
        height: pc(42);
        background: rgba(255, 255, 255, 0.15);
        border-radius: pc(15);
        font-size: pc(18);
        border: none;
        color: #fff;
        cursor: pointer;
      }
    }

    .logout-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: h5(64);
      height: h5(64);
      background: transparent;
      border-radius: h5(12);
      border: none;
      cursor: pointer;

      .logout-icon {
        width: h5(60);
        height: h5(60);
      }
    }

    .login-btn {
      @include adapt($prop: width, $h5: 100%, $pc: 216);
      @include adapt($prop: height, $h5: 60, $pc: 42);
      @include adapt($prop: padding, $h5: 8 34, $pc: 8 34);
      @include adapt($prop: border-radius, $h5: 10, $pc: 10);
      border: none;
      color: #fff;
      background: rgba(255, 255, 255, 0.15);
      cursor: pointer;
    }

    .user-dropdown {
      &.pc {
        position: absolute;
        top: calc(100% + #{pc(15)});
        right: 50%;
        transform: translateX(50%);
        min-width: pc(200);
        padding: pc(20);
        border-radius: pc(24);
        background: linear-gradient(
          180deg,
          rgba(66, 33, 125, 1) 0%,
          rgba(60, 15, 83, 1) 100%
        );
        box-shadow:
          0 pc(8) pc(30) rgba(0, 0, 0, 0.6),
          0 0 pc(20) rgba(138, 43, 226, 0.3);

        &::before {
          content: '';
          position: absolute;
          top: #{pc(-14)};
          right: 50%;
          transform: translateX(50%);
          width: 0;
          height: 0;
          border-left: pc(14) solid transparent;
          border-right: pc(14) solid transparent;
          border-bottom: pc(20) solid rgba(66, 33, 125, 1);
          filter: drop-shadow(0 -pc(2) pc(2) rgba(0, 0, 0, 0.3));
          z-index: 2;
        }

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: pc(24);
          padding: pc(3);
          background: linear-gradient(
            135deg,
            rgba(180, 160, 200, 0.9) 0%,
            rgba(80, 60, 100, 0.3) 30%,
            rgba(40, 25, 60, 0.1) 50%,
            rgba(80, 60, 100, 0.3) 70%,
            rgba(180, 160, 200, 0.9) 100%
          );
          -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
          mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          pointer-events: none;
          z-index: 1;
        }
      }
    }

    .logout-option {
      &.pc {
        font-size: pc(18);
        border-radius: pc(8);
        transition: background 0.2s ease;
        cursor: pointer;
      }
    }
  }
}
</style>
